import { render, staticRenderFns } from "./BulkUpdateCategory.vue?vue&type=template&id=b9bf5310"
import script from "./BulkUpdateCategory.vue?vue&type=script&lang=js"
export * from "./BulkUpdateCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports